// src/contexts/AuthContext.tsx
import { createContext } from 'react';
import { Session } from '@supabase/supabase-js';
import { StudentProfile } from '@/Types/DataTypes';

export interface AuthContextType {
  session: Session | null;
  profile: StudentProfile | null | undefined;
  loading: boolean;
  profileLoading: boolean;
  signOut: () => Promise<void>;
  refreshUser: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
